import { render } from "./VDropdown.vue?vue&type=template&id=11a48d0c"
import script from "./VDropdown.vue?vue&type=script&lang=js"
export * from "./VDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__